module.exports = __webpack_public_path__ + "static/media/person1.0f284113.svg";